import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';
import store, {history} from './store';
import App from './App';
import 'react-dates/initialize'
import {LocalizeProvider} from "react-localize-redux";


import 'semantic-ui-css/semantic.min.css';
import './index.css';

const target = document.querySelector('#root');
render(
    <Provider store={store}>
        <LocalizeProvider store={store}>
            <ConnectedRouter history={history}>
                <div>
                    <App/>
                </div>
            </ConnectedRouter>
        </LocalizeProvider>
    </Provider>,
    target
)




// WEBPACK FOOTER //
// ./src/index.js